import tpl from './reservation-slot-row.tpl.html';
import './reservation-slot-row.component.scss';

import personInfo from './info/person-info.component';
import {momentDefaultTZ} from '../time/time.utils';
import bigButtonComponentMod from '../../../common/material-components/buttons/big-button.component';
import urlServiceMod from '../../common/url.service';


class ReservationSlotRowComponent {
  constructor(UrlService, Raven) {
    'ngInject';

    /**
     * @type {ReservationSlot}
     */
    this.slot = null;

    /**
     * Reservation time formatted for user readability.
     * @type {string}
     */
    this.timeStr = '';
    
    this.UrlService = UrlService;
    this.Raven = Raven;
  }

  $onInit() {
    if (this.slot.start_time) {
      this.timeStr = momentDefaultTZ(this.slot.start_time).calendar();
    }
    try {
      this.link = '';
      this.UrlService.reservationURL(this._reservationParams()).then(url => this.link=url)
        .catch(e => this.Raven.captureException(e, {extra: { reservation: this.slot.id}}));
    } catch (e) {
      this.Raven.captureException(e, {extra: { reservation: this.slot.id}})
    }
  }

  _reservationParams() {
    return {
      personId: this.slot.person.id,
      serviceId: this.slot.service.id,
      locationId: this.slot.location.id,
      timeslotId: this.slot.id
    };
  }
}

const config = {
  templateUrl: tpl,
  controller: ReservationSlotRowComponent,
  bindings: {
    slot: '<'
  }
};

const mod = angular.module('app.common.components.reservationSlotRow', [
  personInfo,
  bigButtonComponentMod,
  urlServiceMod
])

.component('reservationSlotRow', config);

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/components/reservation-slot-row.component.js